import { makeAutoObservable } from 'mobx';
import { ISaveable } from '../../../../../stores/types';
import { ICredentialsStore } from '../integration-store';

export interface IShipedgeCredentials {
    base_url: string,
    api_key: string,
    account_id: string,
    warehouse: string,
    label: boolean
};

class ShipedgeCredentialsStore implements ISaveable, ICredentialsStore {
    private _changes: IShipedgeCredentials = { label: false } as IShipedgeCredentials;

	constructor() {
		makeAutoObservable(this);
	}

    public get base_url() { return this._changes.base_url; }
    public get api_key() { return this._changes.api_key; }
    public get account_id() { return this._changes.account_id; }
    public get warehouse() { return this._changes.warehouse; }
    public get label() { return this._changes.label; }

    public set base_url(v: string) { this._changes.base_url = v; }
    public set api_key(v: string) { this._changes.api_key = v; }
    public set account_id(v: string) { this._changes.account_id = v; }
    public set warehouse(v: string) { this._changes.warehouse = v; }

    /** ICredentialsStore implementation ************/
    public async getCredentials() {
        return { ...this._changes };
    }


    /********* ISaveable implementation *************/
    public hasChanges(): boolean {
        return !!Object.keys(this._changes).length;
    }

    public discardChanges(): void {
        this._changes = {} as IShipedgeCredentials;
    }

    public getUpdatedModel(): IShipedgeCredentials { throw new Error('Not implemented.'); }
    public isSaving(): boolean { throw new Error('Not implemented.'); }
    public commitChanges() { throw new Error('Not implemented.'); }
    public async save() { throw new Error('Not implemented.'); }

    public checkLabelToggle = () => {
        this._changes.label = !this._changes.label;
    }
}

export default ShipedgeCredentialsStore;
